
import { mapState } from 'vuex'

export default {
    props: {
        content: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            modalShow: false,
        }
    },

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),

        image() {
            return process.browser ? (window.innerWidth > 576 ? this.content.bgImage : this.content.mobileBgImage) : null
        },

        bannerBg() {
            if (!this.content.footerSection) return null
            return process.browser ? (window.innerWidth > 576 ? this.content.footerSection.src : this.content.footerSection.mobileSrc) : null
        },

        smDevice() {
            return this.$store.getters['data/smDevice']
        },

        blocks() {
            return this.content.blocks || []
        },
    },

    methods: {
        startSetup() {
            if (this.$auth.loggedIn) {
                if (this.$route.name.includes('submit-wedding')) {
                    this.$router.push({ name: 'tools-submit-wedding-my-weddings' })
                } else if (this.$route.name.includes('guest-list')) {
                    this.$router.push({ name: 'tools-guest-list' })
                } else if (this.$route.name.includes('vendor-manager')) {
                    this.$router.push({ name: 'tools-vendor-manager' })
                } else if (this.$route.name.includes('checklist')) {
                    this.$router.push({ name: 'tools-wedding-checklist' })
                } else if (this.$route.name.includes('vision-boards')) {
                    this.$router.push({ name: 'users-username-boards', params: { username: this.user.username } })
                } else if (this.$route.name.includes('tools-create-or-claim-vendor-profile-setup')) {
                    this.$router.push({ name: 'vendor-management-step', params: { step: '1' } })
                } else if (this.$route.name.includes('tools-cash-registry-setup')) {
                    this.$router.push({ name: 'tools-cash-registry' })
                } else if (this.$route.name.includes('tools-wedding-address-collector-setup')) {
                    this.$router.push({ name: 'tools-guest-list' })
                }
            } else if (this.$route.name.includes('tools-create-or-claim-vendor-profile-setup')) this.$nuxt.$emit('open-register-modal', true)
            else this.modalShow = true
        },
    },
}
